import React from "react";
import { Link } from "react-router-dom";
import { Truck, ArrowRight } from "lucide-react";
import { trackEvent } from "@/lib/retention";
import useBrandAsset from "@/lib/useBrandAsset";

/**
 * Phase 11.5 — Lifted Supplies introduction.
 * INTENTIONALLY LIGHT. The homepage answers "What is Lifted Supplies?"
 * in ~3 sentences and routes to /supplies (full module) or /ecosystem
 * (full explanation). No driver / partner explanations here.
 */
export default function SuppliesIntroSection({ id = "home-supplies" }) {
  const logo = useBrandAsset("logo.supplies");
  return (
    <section
      id={id}
      data-testid={id}
      className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10 py-12"
    >
      <div className="glass-panel glass-panel--purple grid grid-cols-1 lg:grid-cols-12 gap-8 items-center p-6 sm:p-10">
        <div className="lg:col-span-7 fade-up">
          <div className="eyebrow flex items-center gap-2"><Truck className="h-3 w-3" /> Lifted Supplies</div>
          <h2 className="font-anton text-3xl sm:text-4xl uppercase mt-3 leading-[0.95]">
            Same-day supplies.<br /><span className="text-lifted-green">Powered by Lifted.</span>
          </h2>
          <p className="text-lifted-dim text-sm sm:text-base mt-4 max-w-xl">
            Lifted Supplies is part of LiftedAtTheMoment — connecting customers, drivers, and stores in a single
            same-day delivery network.
          </p>
          <div className="mt-6 flex flex-wrap gap-3">
            <Link
              to="/supplies"
              data-testid="supplies-intro-cta-shop"
              className="btn-lifted"
              onClick={() => trackEvent("supplies_cta_click", { surface: "supplies_intro" })}
            >
              Shop Lifted Supplies <ArrowRight className="h-3 w-3" />
            </Link>
            <Link
              to="/ecosystem"
              data-testid="supplies-intro-cta-learn"
              className="btn-ghost"
              onClick={() => trackEvent("supplies_cta_click", { surface: "supplies_intro", cta: "learn_more" })}
            >
              Learn more about the ecosystem
            </Link>
          </div>
        </div>
        <div className="lg:col-span-5 flex justify-center">
          {logo?.url ? (
            <img src={logo.url} alt={logo.alt || "Lifted Supplies"} className="max-h-44 w-auto" loading="lazy" />
          ) : (
            <div className="h-44 w-44 rounded-full bg-lifted-green/15 border border-lifted-green/30 grid place-items-center">
              <Truck className="h-12 w-12 text-lifted-green" />
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
